import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const FontDefault: React.FC<Props> = ({
  className,
  width = 25,
  height = 16,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.63391 0.5H8.15391L13.6139 15H11.1339L9.99391 11.82H3.69391L2.57391 15H0.253906L5.63391 0.5ZM4.37391 9.9H9.29391L6.81391 2.98L4.37391 9.9ZM14.4709 12.1C14.4709 9.48 17.5509 8.78 21.7309 8.34V8.12C21.7309 6.22 20.7309 5.58 19.4109 5.58C17.9709 5.58 17.1509 6.32 17.0709 7.64H14.9709C15.1509 5.36 17.0309 3.98 19.4909 3.98C22.2709 3.98 23.8709 5.32 23.8309 8.54C23.8309 8.8 23.7909 10.66 23.7909 11.12C23.7909 12.72 23.8909 14.04 24.0909 15H22.0909C22.0109 14.58 21.9509 14.26 21.9109 13.58C21.2709 14.66 20.0509 15.26 18.3109 15.26C16.1309 15.26 14.4709 14.06 14.4709 12.1ZM21.8309 9.88C18.4909 10.2 16.7309 10.66 16.7309 12.06C16.7309 13.04 17.5109 13.66 18.7709 13.66C20.4909 13.66 21.8309 12.8 21.8309 10.66V9.88Z"
        fill="#2F7FEF"
      />
    </svg>
  )
}
